module.exports = __webpack_public_path__ + "files/logo.ee65c811cf254bb3bdfe716abacc528e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/vendor/ec-fe-bo-template/images/logo.svg
// module id = 1165
// module chunks = 0